module.exports = __webpack_public_path__ + "assets/img/small_QRCode.2d28f4f5.svg";